/**
 * CorrelationTags — collapsible list of the correlation tags the payment is
 * findable by. Pure presentational; renders nothing when there are none.
 */
import SpaceBetween from '@cloudscape-design/components/space-between';
import ExpandableSection from '@cloudscape-design/components/expandable-section';
import { CopyableText } from 'src/components/common/CopyableText';

interface CorrelationTagsProps {
  tags: string[];
}

export const CorrelationTags = ({ tags }: CorrelationTagsProps) => {
  if (tags.length === 0) return null;

  return (
    <ExpandableSection variant="footer" headerText={`Tags (${tags.length})`}>
      <SpaceBetween size="xxs">
        {tags.map(tag => (
          <div
            key={tag}
            style={{ fontFamily: 'Monaco, Menlo, Consolas, monospace', fontSize: 12, overflowWrap: 'anywhere' }}
          >
            <CopyableText value={tag} />
          </div>
        ))}
      </SpaceBetween>
    </ExpandableSection>
  );
};
